export const environment = {
  production: true,
  api_server: 'https://api.getclasshive.com'
};
